import { ReactNode } from "react";
import { BadgeIcon } from "./Icons";

type Plan = {
  name: string;
  tag: string;
  description: string;
  icon: ReactNode;
  badge?: boolean;
};

export const PlanCard = ({ plan }: { plan: Plan }) => {
  return (
    <div className="plan-card">
      {plan.icon}
      {plan.badge && (
        <span className="badge-card">
          <BadgeIcon />
        </span>
      )}
      <div className="plan-title-price">
        <h3>{plan.name}</h3>
        <span>{plan.tag}</span>
      </div>
      <p>{plan.description}</p>
    </div>
  );
};
